<template>
  <SlidingPanel
    :isPanelVisible="isPanelOpen"
    :onClose="onClose"
    :on-confirm="onClose"
    :close-title="t('travellers.title')"
    :display-confirm-button="true"
    :is-loading="loading"
    :has-overlay="true"
  >
    <section class="d-flex flex-column gap-3 p-2 p-lg-0">
      <PanelIntro />
      <TravellersList
        v-if="selectedBooking"
        :travellers="selectedBooking.travellers"
        :departure-date="selectedBooking.departureDate"
        :panel-mode="true"
      />
    </section>
  </SlidingPanel>
</template>

<script lang="ts" setup>
  // Vue
  import { ComputedRef, computed, defineProps } from 'vue'

  // Types
  import { BookingSummary } from '@/services/BookingService.interface'

  // Components
  import SlidingPanel from '@/components/UI/SlidingPanel.vue'
  import TravellersList from './TravellersList.vue'
  import PanelIntro from './TravellersPanelIntro.vue'

  // Config
  import { ModalId } from '@/config/modalIds'

  // Store
  import { useStore } from '@/store'
  const store = useStore()

  // Translations
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n()

  // Methods
  const onClose = (): void => {
    store.commit('modal/close', ModalId.TRAVELLER_PANEL)
  }

  // Computed
  const isPanelOpen: ComputedRef<boolean> = computed(() => {
    const checkIsOpen = store.getters['modal/isOpen']
    return checkIsOpen(ModalId.TRAVELLER_PANEL)
  })

  // Get the selected booking from the Vuex store
  const selectedBooking: ComputedRef<BookingSummary | null> = computed(
    () => store.getters['booking/selectedBooking']
  )

  const loading: ComputedRef<boolean> = computed(() =>
    store.getters['booking/isLoading']('updateTraveller')
  )
</script>
